<!-- Do not change this file. -->

<template>
  <div id="footer">
    <div class="container-fluid border-top py-1 text-small">
      <div class="d-flex justify-content-between" role="contentinfo">
        <div class="text-start my-auto me-5">
          &copy; {{ year }} Oregon State University
        </div>

        <div class="text-start">
          <div class="row g-0 justify-content-end">
            <div class="col-6 col-sm-auto" v-if="isAdmin">
              <RouterLink
                :to="{ name: 'Participants' }"
                class="nav-link ms-3 my-auto text-primary"
                >Admin</RouterLink
              >
            </div>
            <div
              class="col-6 col-sm-auto"
              v-if="isAdmin && $route.name === 'Admin'"
            >
              <RouterLink
                :to="{ name: 'Activity' }"
                class="nav-link ms-3 my-auto text-primary"
                >Activity</RouterLink
              >
            </div>
            <div class="col-6 col-sm-auto">
              <TheVersion />
            </div>
            <div class="col-6 col-sm-auto">
              <DataCollectionModal />
            </div>
            <div class="col-6 col-sm-auto">
              <a
                class="ms-3 my-auto"
                rel="noopener"
                target="_blank"
                href="https://oregonstate.edu/digital-millennium-copyright-act"
                >Copyright</a
              >
            </div>
            <div class="col-6 col-sm-auto">
              <a
                class="ms-3 my-auto"
                rel="noopener"
                target="_blank"
                href="https://oregonstate.edu/official-web-disclaimer"
                >Disclaimer</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */
import DataCollectionModal from "@/components/core/DataCollectionModal.vue";
import TheVersion from "@/components/core/TheVersion.vue";
import { mapGetters } from "vuex";

export default {
  name: "TheFooter",
  components: {
    TheVersion,
    DataCollectionModal
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    year() {
      const currentYear = new Date().getFullYear(); // YYYY

      let yearString = "";
      let publishYear = this.$s("meta.publishedYear");
      /* Return just a single year */
      if (currentYear === publishYear) {
        yearString = `${currentYear}`;
      } else {
        /* Return a year range */
        yearString = `${publishYear} - ${currentYear}`;
      }

      return yearString;
    }
  }
};
</script>
